import { render } from "./MuddemaalCreate.vue?vue&type=template&id=41111410&scoped=true"
import script from "./MuddemaalCreate.vue?vue&type=script&lang=js"
export * from "./MuddemaalCreate.vue?vue&type=script&lang=js"

import "./MuddemaalCreate.vue?vue&type=style&index=0&id=41111410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41111410"]])

export default __exports__